import React from "react";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import { useMyGames } from "@seabrookstudios/pitch2table";
import { DateTime } from "luxon";
import { RecentGamesCardGameListEntry2 } from "../games/ListItem";

/**
 * @param {number} days
 */
const daysAgo = (days) => DateTime.now().minus({ days }).startOf("day").toMillis();

export const RecentGamesCard = () => {
  const { data: games = [], isLoading } = useMyGames();

  const recentGames = games
    .filter((game) => !game.archived && game.updated > daysAgo(7))
    .sort((a, b) => (b.updated || 0) - (a.updated || 0));

  if (isLoading || recentGames.length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader title="Recent Games" subheader={"Games with activity in the last 7 days"} />
      <CardContent>
        <List dense>
          {recentGames.map((game) => (
            <ListItem key={game.id}>
              <RecentGamesCardGameListEntry2 item={game} />
            </ListItem>
          ))}
        </List>
      </CardContent>
    </Card>
  );
};
